import { styled, makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'

export const Header = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
  fontWeight: '700',
}))

export const HelperText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

export const QuestionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}))

export const InputWrapper = styled(Box)(({ theme }) => ({
  '& .text-input': {
    marginBottom: theme.spacing(2),
  },
}))

export const NextButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(12),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

export const useStyles = makeStyles(theme => ({
  sectionTitle: {
    marginBottom: '24px',
  },
  root: {
    display: 'block',
    border: '1px solid #E0E0E0',
    height: '164px',
    borderRadius: '4px',
    position: 'relative',
    width: '100%',
    padding: '0px 16px',
    margin: '0px',
    boxSizing: 'border-box',
    '& span': {
      display: 'none',
    },
    '& .MuiTypography-root': {
      fontSize: '40px',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.24)',
    },
  },
  label: {
    display: 'none',
  },
  formControlLabel: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '20px',
    width: '100%',
    textAlign: 'center',
    boxSizing: 'border-box',
    padding: '16px',
  },
  checked: {
    backgroundColor: 'rgba(0, 35, 75, 0.24)',
  },
  customControlLabel: {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: '164px',
    margin: '0px',
  },
  answersList: {
    '& + &': {
      display: 'inline-block',
      '&:before': {
        content: "','",
        marginRight: '10px',
      },
    },
  },
}))
